import useCopilotAccountOwnerId from 'components/CopilotControl/hooks/useCopilotAccountOwnerId'
import useCopilotPatientsList from 'components/CopilotControl/hooks/useCopilotPatientsList'
import _ from 'lodash'
import React, { useMemo, useState } from 'react'
import {
  useFetchScanningScheduleAggregationQuery,
  useFetchScanningSchedulePatientsInfiniteQuery
} from 'store/modules/CopilotControl'
import PatientsList from '../../common/PatientsList/PatientsList'
import PatientsScanningScheduleHeaderSkeleton from './PatientsScanningScheduleHeaderSkeleton'
import PatientsScanningScheduleListHeader from './PatientsScanningListHeader'
import PatientsScanningScheduleListItem from './PatientsScanningScheduleListItem'
import PatientsListError from '../PatientsListError'
import useEngagementsWidget from '../../common/EngagementWidget/useEngagementsWidget'
import { CopilotEngagementTypes } from 'consts/copilotControlConsts'

const PatientsScanningScheduleList = () => {
  const accountOwnerId = useCopilotAccountOwnerId()
  const { isStatusesLoading } = useCopilotPatientsList()
  const [selectedCategories, setSelectedCategories] = useState([])

  const { data: scanningScheduleData = {}, isLoading: isLoadingAggregations } =
    useFetchScanningScheduleAggregationQuery({ accountOwnerId }, { skip: !accountOwnerId })

  const {
    data: patients = [],
    isLoading,
    isFetching,
    isFetchingNextPage,
    fetchNextPage
  } = useFetchScanningSchedulePatientsInfiniteQuery(
    {
      accountOwnerId,
      categories: selectedCategories
    },
    {
      skip: !accountOwnerId
    }
  )

  const { scoreOptions } = useEngagementsWidget({
    engagementType: CopilotEngagementTypes.ScanningSchedule,
    values: scanningScheduleData
  })

  const patientsPaginatedData = useMemo(() => {
    return patients.pages?.map(page => page.items).flat() || []
  }, [patients])

  const hasMorePages = _.last(patients?.pages || [])?.hasMore
  const isListLoading = isLoading || isStatusesLoading || isFetching

  return (
    <PatientsList
      isHeaderLoading={isLoadingAggregations}
      isListLoading={isListLoading && !isFetchingNextPage}
      isEmpty={false}
      fetchNextPage={fetchNextPage}
      hasMorePages={hasMorePages}
      patients={patientsPaginatedData}
      scoreOptions={scoreOptions}
      EmptyStateComponent={<PatientsListError />}
      HeaderSkeletonComponent={<PatientsScanningScheduleHeaderSkeleton />}
      PatientsHeaderComponent={
        <PatientsScanningScheduleListHeader
          scoreOptions={scoreOptions}
          selectedCategories={selectedCategories}
          setSelectedCategories={setSelectedCategories}
        />
      }
      PatientListItemComponent={PatientsScanningScheduleListItem}
    />
  )
}

export default PatientsScanningScheduleList
